import { Injectable } from '@angular/core';
import { User } from './model/User.model';
import { EnvironmentService } from '../environment/environment.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from '../error/error.service';
import { Router } from '@angular/router';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';
import { AbstractEntityService } from '@app/shared/service/base/abstractEntityService';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from '../password/change-password.component';
import { ChangePassword } from '../password/changePassword.model';

@Injectable({
  providedIn: 'root'
})
export class UserService extends AbstractEntityService {

  constructor(
    public environtmentService: EnvironmentService,
    public httpClient: HttpClient,
    public router: Router,
    public errorService: ErrorService,
    private modalService: NgbModal
  ) {
    super(
      httpClient,
      environtmentService,
      router,
      errorService
    );
    this.baseApiUrl = 'api';
  }

  getEntityName(): string {
    return EntityCV.all.USER;
  }
  // getIdFromEntity(user: User): string {
  //   return user.username;
  // }
  getURLIdFromEntity(user: User): string {
    return user.username;
  }

  getMe(): Observable<User> {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/me`;
    return this.httpClient.get<User>(urlApi, {headers: this.getHeaders()})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  isAvailableUsername(username: string): Observable<User> {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/checkUsernameAvailability`;
    return this.httpClient.get<User>(urlApi, {headers: this.getHeaders(), params: {username}})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  isAvailableEmail(email: string): Observable<User> {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/checkEmailAvailability`;
    return this.httpClient.get<User>(urlApi, {headers: this.getHeaders(), params: {email}})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  public changePassword(username: string, changePassword: ChangePassword): Observable<EntityInterface> {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/changePassword/${username}`;
    const observable: Observable<EntityInterface> = this.httpClient.patch<EntityInterface>(urlApi, changePassword, {headers: this.getHeaders()})
    // añadimos el manejo de errores
    .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true, `entity.${this.getEntityName().charAt(0).toLowerCase() + this.getEntityName().slice(1)}.error.update`) ));
    return observable;
  }

  public openChangePassword(modal: boolean, afterLogin: boolean) {
    const modalRef = this.modalService.open(ChangePasswordComponent, { size: 'lg', centered: true, backdrop: modal ? 'static': true, keyboard: !modal });
    modalRef.componentInstance.modal = modal;
    modalRef.componentInstance.afterLogin = afterLogin;
  }

  public resetLoginFailedNumber(username: String): Observable<EntityInterface> {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/resetLoginFailedNumber/${username}`;
    // const observable: Observable<EntityInterface> = this.httpClient.patch<EntityInterface>(urlApi, null, {headers: this.getHeaders()})
    const observable: Observable<EntityInterface> = this.httpClient.post<EntityInterface>(urlApi, {headers: this.getHeaders()})
    // añadimos el manejo de errores
    .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true, `entity.${this.getEntityName().charAt(0).toLowerCase() + this.getEntityName().slice(1)}.error.update`) ));
    return observable;
  }

}
